import React from "react";

import CloseIcon from "@/icons/ui/buttons/close.svg";
import { cn } from "@/utils/cn";

import { TColor } from "./types";

interface CloseButtonProps {
  size?: number;
  color?: TColor;
  ariaLabel?: string;
  className?: string;
  iconClassName?: string;
  onClick?: () => void;
}

export const CloseButton = ({
  size = 24,
  color = "red",
  onClick,
  className,
  iconClassName,
  ariaLabel = "Close",
}: CloseButtonProps) => {
  switch (color) {
    case "red":
      className = cn("text-red", className);
      break;
    case "white":
      className = cn("text-white", className);
      iconClassName = cn("stroke-black", iconClassName);
      break;
    case "dark":
      className = cn("text-gray-1200", className);
      break;
  }

  return (
    <button
      className={cn(
        "cursor-pointer hover:css-rotate-90 hover:transition-rotate ease-liner",
        className,
      )}
      type="button"
      aria-label={ariaLabel}
      onClick={onClick}
    >
      <CloseIcon
        className={cn(iconClassName)}
        width={size}
        height={size}
      />
    </button>
  );
};

export default CloseButton;
